import { render, staticRenderFns } from "./Cronogramaobra.vue?vue&type=template&id=a58a8710&scoped=true&"
import script from "./Cronogramaobra.vue?vue&type=script&lang=js&"
export * from "./Cronogramaobra.vue?vue&type=script&lang=js&"
import style0 from "./Cronogramaobra.vue?vue&type=style&index=0&id=a58a8710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58a8710",
  null
  
)

export default component.exports